// extracted by mini-css-extract-plugin
export default {"NavItem":"NavItem_NavItem__k+np9","active":"NavItem_active__lGCd3","linkWrapper":"NavItem_linkWrapper__iVZUw","scrolled":"NavItem_scrolled__9CGvJ"};